<template>
	<section class="feature_welcome">
		<div class="container">
			<div class="inner">
				<div class="content">
					<h1
						v-if="featureTitle"
						v-html="featureTitle"
					></h1>

					<div
						class="copy"
						v-if="featureCopy"
						v-html="featureCopy"
					></div>

				</div>
			</div>
		</div>
	</section>
</template>

<script>
import SampleImage from '../../images/sample.jpg';

export default {
  data() {
    return {
      sampleImage: SampleImage,
    };
  },

  props: {
    featureTitle: {},
    featureCopy: {},
    buttons: {},
    showBreadcrumbs: {
      default: 'no',
    },
  },

  computed: {},

  watch: {},

  methods: {},

  components: {

  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.feature_welcome {
  width: 100%;
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: $lg) {
    min-height: auto;
    margin: 0 0 0;
    width: 100%;
  }

  > .container {
    .inner {
      background: lighten($cpmec-grey, 60);
      grid-template-columns: 0.5fr 1fr 0.5fr;
      width: 100%;

      @media (max-width: 1740px) {
        width: 100%;
      }

      @media (max-width: $lg) {
        grid-template-columns: 1fr;
        width: 100%;
      }

      .content {
        order: 0;
        text-align: center;
        grid-column: 2 / span 1;

        @media (max-width: $lg) {
          order: 1;
        }
      }

      .image {
        order: 1;

        @media (max-width: $lg) {
          order: 0;
          height: 240px;
          margin-top: -20px;
          overflow: hidden;
          padding: 0;
        }
      }
    }
  }

  .inner {
    display: grid;
    overflow-x: hidden;

    @media (max-width: $lg) {
      padding: 0 0;
      overflow-x: visible;
    }

    .copy {
      margin: 0 0 $spacer * 2;

      @media (max-width: $lg) {
        margin: 0 0 $spacer * 2;
        padding: 0 $spacer;
      }

      a {
        color: $cpmec-blue;
        margin: 0 0 $spacer * 2;
        font-size: 25px;
        text-decoration: none;

        @media (max-width: $lg) {
          font-size: 18px;
          margin: 0 0 $spacer;
        }
      }

      p {
        color: $cpmec-blue;
        margin: 0 0 $spacer * 2;
        font-size: 25px;

        &:first-child {
          color: $cpmec-blue;
        }

        @media (max-width: $lg) {
          font-size: 18px;
          margin: 0 0 $spacer;
        }
      }

      &.two {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: auto;
        margin: 0;

        @media (max-width: $lg) {
          min-height: auto;
          order: 1;
        }
      }
    }

    .half {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .site_button {
        margin-bottom: $spacer;
      }

      &.content {
        padding-top: $spacer * 3;

        @media (max-width: $lg) {
          padding: $spacer * 2 0 $spacer;
        }

        h1 {
          color: white;
          margin: 0 0 $spacer * 2;
          font-size: 80px;
          line-height: 104px;
          font-family: $font-family;
          font-weight: normal;

          @media (max-width: $lg) {
            font-size: 50px;
            line-height: 74px;
            margin: 0 0 $spacer;
            padding: 0 $spacer;
          }

          @media (max-width: $md) {
            font-size: 45px;
            line-height: 60px;
            margin: 0 0 0;
          }

          @media (max-width: $xs) {
            font-size: 40px;
            line-height: 45px;
            margin: 0 0 0;
          }
        }

        .copy {
          margin: 0 0 $spacer * 2;

          @media (max-width: $lg) {
            margin: 0 0 $spacer;
          }

          a {
            color: white;
            margin: 0 0 $spacer * 2;
            font-size: 25px;
            text-decoration: none;

            @media (max-width: $lg) {
              font-size: 18px;
              margin: 0 0 $spacer;
            }
          }

          p {
            color: white;
            margin: 0 0 $spacer * 2;
            font-size: 25px;

            &:first-child {
              color: white;
            }

            @media (max-width: $lg) {
              font-size: 18px;
              margin: 0 0 $spacer;
            }
          }

          & .two {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }

      img {
        width: 100%;
        height: var(--image-max-height);
        object-fit: cover;
        max-height: var(--image-max-height);
        max-width: 100%;

        // @media (max-width: $lg) {
        // 	margin-top: -20px;
        // 	position: absolute;
        // 	z-index: 100;
        // 	width: calc(100% - 40px);
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeatureWelcome.vue